<div [attr.data-sortable]="column().sortable !== false" class="px-3 py-4 font-bold">
    <div class="flex items-center select-none whitespace-nowrap {{column().classes}}">
      @if (column().options) {
        <app-price-results-header-column [column]="column()"></app-price-results-header-column>
      } @else {
        <div>{{ column().header }}</div>
      }

      @if (column().sortable) {
        <div (click)="toggleSort()" class="cursor-pointer ms-2">

          @if(columnIsSorted()) {
            @if(sortDirectionIsAsc()) {
              <app-icons icon="sort-asc"/>
            } @else {
              <app-icons icon="sort-desc"/>
            }
          } @else {
            <app-icons icon="sort"/>
          }
        </div>

      }
    </div>
</div>
